import { Link } from 'react-router'
import { Loader2, CheckCircle2, AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useEmailVerificationForm } from './EmailVerificationForm.logic'

export function EmailVerificationForm() {
  const { t, status, errorMessage } = useEmailVerificationForm()

  if (status === 'verifying') {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10">
              <Loader2 className="size-6 animate-spin text-primary" />
            </div>
            <h3 className="mb-2 text-lg font-medium">{t('verifyingEmail')}</h3>
          </div>
        </CardContent>
      </Card>
    )
  }

  if (status === 'success') {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10">
              <CheckCircle2 className="size-6 text-primary" />
            </div>
            <h3 className="mb-2 text-lg font-medium">{t('emailVerified')}</h3>
            <p className="mb-6 text-sm text-muted-foreground">{t('emailVerifiedMessage')}</p>
            <Button asChild className="w-full">
              <Link to="/dashboard">{t('goToDashboard')}</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
            <AlertTriangle className="size-6 text-destructive" />
          </div>
          <h3 className="mb-2 text-lg font-medium">{t('verificationFailed')}</h3>
          <p className="mb-6 text-sm text-muted-foreground">{errorMessage}</p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">{t('backToLogin')}</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
